 <template>
  <div class="membership-program-new-member wrapper">
    <p class="subtitle has-text-link" style="margin-bottom: 12px">
      <span v-if="showToCustomer" @click="showToCustomer = false">
        Please Enter Your Info
        <i class="fa fa-briefcase is-pulled-right" />
      </span>
      <span v-else @click="showToCustomer = true">
        New Member Details
        <i class="far fa-user is-pulled-right" />
      </span>
    </p>

    <div class="field">
      <i class="hint">Same as TUK login</i>
      <label class="label">Mobile </label>
      <div class="control">
        <input
          class="input"
          v-model="mobile"
          type="text"
          placeholder="e.g 0912346724"
        />
      </div>
    </div>

    <div class="field">
      <i class="hint">Optional</i>
      <label class="label">Name</label>
      <div class="control">
        <input
          class="input"
          v-model="name"
          type="text"
          placeholder="e.g. John Doe"
        />
      </div>
    </div>

    <div class="field">
      <i class="hint">Optional</i>
      <label class="label">E-mail</label>
      <div class="control">
        <input
          class="input"
          v-model="email"
          type="text"
          placeholder="e.g. johndoe@gmail.com"
        />
      </div>
    </div>

    <div v-if="!showToCustomer">
      <div class="field">
        <i class="hint">Optional</i>
        <label class="label">Membership Number</label>
        <div class="control">
          <input
            class="input"
            v-model="membershipNumber"
            type="text"
            placeholder="e.g. 2020026"
          />
        </div>
      </div>

      <div class="field">
        <i class="hint">Optional</i>
        <label class="label">Notes</label>
        <div class="control">
          <textarea
            class="textarea"
            v-model="notes"
            type="text"
            rows="2"
            placeholder="Special pricing, VIP, bulk buyer etc"
          />
        </div>
      </div>

      <div class="field">
        <label class="label">Expiry Days</label>
        <div class="control">
          <div class="buttons">
            <span
              v-for="d in expiryOptions"
              :key="d"
              class="button"
              :class="{ 'is-info': expiry === d }"
              @click="expiry = d"
            >
              {{ d }}
            </span>
            <span
              class="button"
              :class="{ 'is-info': expiry > 365 }"
              @click="expiry = 9999"
            >
              <i class="fa fa-infinity" />
            </span>
          </div>
        </div>
      </div>
    </div>

    <div style="margin-top: 20px">
      <button class="button is-link" @click="submit" :disabled="!mobile">
        {{ $t("submit") }}
      </button>
      <button class="button is-white is-pulled-right" @click="$emit('close')">
        {{ $t("cancel") }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    w: Object,
  },
  data() {
    return {
      showToCustomer: false,
      mobile: null,
      name: null,
      email: null,
      membershipNumber: null,
      notes: null,
      expiry: 365,
      expiryOptions: [30, 90, 180, 365],
    };
  },
  methods: {
    parsePhone() {
      var s = this.mobile;
      // check if contains any non-numeric chars after initial +
      // tODO
      // assume a + country code is correct, just remove any white spaces
      if (s[0] === "+") return s.replace(/\s+/g, "");
      // assume starting with 0 means thai number
      if (s[0] === "0") return "+66" + s.substring(1).replace(/\s+/g, "");
      // otherwise invalid
      return null;
    },
    submit() {
      if (!this.mobile) this.errorToast("Mobile number is required");
      if (this.mobile.length < 9) this.errorToast("Invalid phone number");
      if (!this.parsePhone()) this.errorToast("Invalid phone number");
      this.createMemberRole();
    },
    createMemberRole() {
      var data = {
        name: this.name,
        email: this.email,
        membership_number: this.membershipNumber,
        notes: this.notes,
        membership_length: this.expiry,
        expiry_date: new Date(this.valueOf() + 24 * 60 * 60 * this.expiry),
      };
      this.$store
        .dispatch("createRole", {
          phone_number: this.parsePhone(),
          business_id: this.w.business_id,
          workflow_id: this.w.id,
          workflow_name: this.w.name,
          role_type: "customer",
          role_name: "Member",
          data: data,
        })
        .then((res) => {
          this.console("createMemberRole success", res);
          this.success();
          this.$emit("new");
        })
        .catch((err) => this.apiError(err));
    },
  },
};
</script>

<style scoped>
.wrapper {
  background-color: #eee;
  text-align: left;
  border-radius: 4px;
}
.hint {
  float: right;
  font-size: 0.7;
  font-weight: 500;
  opacity: 0.6;
}
</style>